// extracted by mini-css-extract-plugin
export default {"gameBalanceCard":"GameBalanceCard_gameBalanceCard__V3MtW","gameBalanceName":"GameBalanceCard_gameBalanceName__C4vSw","gameBalanceAmount":"GameBalanceCard_gameBalanceAmount__UqSHt"};